import React from 'react'

import { buildComponent } from '../../../../components/factory'
import { Category } from '../../../../state/models/audio'
import { graphql } from '../../../../services/graphql'
import { serviceModals } from '../../../../services/modals'

import * as UI from '@mantine/core'
import * as Icons from '../../../../components/icons'
import * as Routing from 'wouter'

const typeLabels = {
  theme: 'Thématique',
  book: 'Audiobook',
  background: 'Fond sonore',
}

const typeColors = {
  theme: 'blue',
  book: 'green',
  background: 'orange',
} as const

export const CategoryRow = buildComponent<
  Category & {
    isSelected: (item: string) => boolean
    toggleRow: (item: string) => void
  }
>()
  .withLifecycle(({ props }) => {
    const handleDelete = async (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()

      try {
        await serviceModals.confirmDeletion(
          'Supprimer la catégorie',
          `Voulez-vous vraiment supprimer la catégorie "${
            props.short?.fr || props.short?.en || props.slug
          }" ?`,
        )

        await graphql.mutations.deleteCategory(props._id)
      } catch (err) {
        console.error('Erreur lors de la suppression:', err)
      }
    }

    return { handleDelete }
  })
  .withRender(({ props, lifecycle }) => {
    const { isSelected, toggleRow, ...item } = props
    const selected = isSelected(item._id)

    return (
      <UI.Group
        sx={(theme) => ({
          height: '6rem',
          background: selected
            ? theme.colors[theme.primaryColor][0]
            : 'transparent',
          ':hover': {
            background: selected
              ? theme.colors[theme.primaryColor][1]
              : 'rgba(0, 0, 0, 0.02)',
          },
        })}
        align="center"
        px={16}
        noWrap
      >
        <UI.Group
          align="center"
          position="center"
          style={{ width: '4rem', flex: 'none' }}
        >
          <UI.Checkbox
            checked={selected}
            onChange={() => toggleRow(item._id)}
            transitionDuration={0}
          />
        </UI.Group>
        {/* Colonne Catégorie */}
        <div style={{ width: '20rem', flex: 'none' }}>
          <UI.Group spacing="sm">
            <UI.Text size="sm" weight={500}>
              {item.parent
                ? item.parent.short?.fr || item.parent.short?.en || '--'
                : item.short?.fr || item.short?.en || item.slug}
            </UI.Text>
          </UI.Group>
        </div>
        {/* Colonne Sous-catégorie */}
        <div style={{ width: '20rem', flex: 'none' }}>
          {item.parent ? (
            <UI.Text size="sm" color="dimmed">
              {item.short?.fr || item.short?.en || item.slug}
            </UI.Text>
          ) : (
            <UI.Text size="sm" color="dimmed">
              --
            </UI.Text>
          )}
        </div>

        {/* Colonne Type */}
        <div style={{ flex: 1 }}>
          <UI.Badge color={typeColors[item.type]} size="sm">
            {typeLabels[item.type]}
          </UI.Badge>
        </div>

        <div style={{ width: 96 }}>
          <UI.Group spacing="xs">
            <Routing.Link to={`/categories/edit/${item._id}`}>
              <UI.ActionIcon
                size="lg"
                color="blue"
                component="a"
                sx={{
                  width: 32,
                  height: 32,
                }}
              >
                <Icons.FontAwesomeIcon
                  color="rgba(0, 0, 0, 0.5)"
                  icon={Icons.Solid.faPen}
                />
              </UI.ActionIcon>
            </Routing.Link>
            <UI.ActionIcon
              size="lg"
              color="red"
              sx={{
                width: 32,
                height: 32,
              }}
              onClick={lifecycle.handleDelete}
            >
              <Icons.FontAwesomeIcon
                color="rgba(220, 53, 69, 0.8)"
                icon={Icons.Solid.faTrash}
              />
            </UI.ActionIcon>
          </UI.Group>
        </div>
      </UI.Group>
    )
  })
